export default __webpack_public_path__ + "static/media/blur.874b3e1c.webp";